module.exports = require("@mui/icons-material/AddPhotoAlternate");